export default {
	data() {
		return {
			curIdx: -1,
			menuList: [{
				caption: '首  页',
				captionEn: 'HOME',
				path: '/index'
			}, {
				caption: '核心技术',
				captionEn: 'CORE TECHNOLOGY',
				path: '/coreTechnology'
			}, {
				caption: '产品服务',
				captionEn: 'PRODUCTS AND SERVICES',
				path: '/product'
			}, {
				caption: '项目案例',
				captionEn: 'PROJECT CASES',
				path: '/project'
			}, {
				caption: '关于蓝鲸',
				captionEn: 'ABOUT US',
				path: '/aboutMe'
			}],
			otherMenus: [{
				caption: '搜索结果',
				captionEn: 'SEARCH RESULT',
				path: '/search'
			},{
				caption: '联系我们',
				captionEn: 'CONTACT US',
				path: '/contactUs'
			},{
				caption: '申领样品',
				captionEn: 'APPLY FOR SPECIMEN',
				path: '/sample'
			}]
		}
	},
	mounted() {
		if(this.$route && this.$route.path) {
			const item = this.menuList.filter(it => it.path == this.$route.path)[0];
			this.curIdx = item ? this.menuList.indexOf(item) : -1;
		}
	},
	methods: {
		onClickHomeLogo(){
			this.curIdx = -1;
			this.$router.push({path: '/index'});
		},
		onClickMenuItem(idx) {
			this.curIdx = idx;	
			this.$router.push({path: this.menuList[idx].path});
		}
	}
}